import { EUserOrderBy } from 'src/common/constants/userSortKeys';
import { checkForAllWords } from 'src/helpers/search';
import { EOrder } from 'src/interfaces/Order';
import { IUser } from 'src/interfaces/User';

type UserFilterOptions = {
  query: string;
  roleFilter: string | null;
  orderBy: EUserOrderBy;
  orderDir: EOrder;
};

function matchesQuery(user: IUser, query: string): boolean {
  const q = query.trim();
  if (!q) return true;
  return (
    !!checkForAllWords(q, user.name || '') ||
    !!checkForAllWords(q, user.email || '') ||
    !!checkForAllWords(q, String(user.role?.name || user.role?.roleId || ''))
  );
}

export function filterUsers(
  users: IUser[],
  { query, roleFilter, orderBy, orderDir }: UserFilterOptions,
): IUser[] {
  let result = users.filter(user => {
    if (roleFilter && user.role?.id !== roleFilter) return false;
    return matchesQuery(user, query);
  });

  result = [...result].sort((a, b) => {
    const av =
      orderBy === EUserOrderBy.name
        ? a.name
        : orderBy === EUserOrderBy.email
          ? a.email
          : String(a.role?.name || a.role?.roleId);
    const bv =
      orderBy === EUserOrderBy.name
        ? b.name
        : orderBy === EUserOrderBy.email
          ? b.email
          : String(b.role?.name || b.role?.roleId);
    return (
      String(av || '').localeCompare(String(bv || ''), undefined, { sensitivity: 'base' }) *
      (orderDir === EOrder.asc ? 1 : -1)
    );
  });

  return result;
}
